// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/admin-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-page{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: auto;
    padding-inline: 30px;
    padding-block: 20px;
}

.admin-banner{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 30vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 10px;

}

.banner-ai{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-inline: 10px;
    padding-block: 7px;
    gap: 10px;
    background-color: white;
    border-radius: 5px;
    cursor: pointer;
}

.logo-company{
    width: 200px;
    height: 200px;
    object-fit: cover;
    border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/Components/style/admin.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,yDAA6D;IAC7D,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":[".admin-page{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: auto;\n    padding-inline: 30px;\n    padding-block: 20px;\n}\n\n.admin-banner{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    min-height: 30vh;\n    background-image: url('../../assets/images/admin-banner.jpg');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    border-radius: 10px;\n\n}\n\n.banner-ai{\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding-inline: 10px;\n    padding-block: 7px;\n    gap: 10px;\n    background-color: white;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.logo-company{\n    width: 200px;\n    height: 200px;\n    object-fit: cover;\n    border-radius: 50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
